import { Box, Flex, useDisclosure } from "@chakra-ui/react";

import SideBar from "@/components/companies/companiesCard/SideBar/SideBar";
import { MainWrapper } from "@/components/ui/box/MainWrapper";
import FilterAndSortBy from "@/components/ui/FilterAndSortBy";
import FilterMobileBlock from "@/components/ui/FilterMobileBlock";
import { useStartListHook } from "@/hooks/useRenderHook";

import { FundsCards } from "./fundsMainComponent/FundsCards";

export const FundsMain = ({ filtersList, startList }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  useStartListHook({ startList });

  return (
    <MainWrapper
      customStyleOuter={{
        mb: { base: "60px", md: "80px", lg: "120px" },
        h: "fit-content",
        px: { base: "20px", md: "40px" },
      }}
    >
      <Box mb={"36px"}>
        <FilterAndSortBy handleClick={onOpen} />
      </Box>

      <Flex justifyContent={"space-between"} alignItems={"start"}>
        <Box display={{ base: "none", lg: "block" }} mr={"20px"}>
          <SideBar {...{ filtersList, pathName: "investors" }} />
        </Box>
        <FundsCards />
      </Flex>
      <FilterMobileBlock
        onClose={onClose}
        isOpen={isOpen}
        filtersList={filtersList}
        pathName={"investors"}
      />
    </MainWrapper>
  );
};
